import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface DownloadingCasesState {
  isDownloading: boolean;
}

const initialState: DownloadingCasesState = {
  isDownloading: false
} satisfies DownloadingCasesState;
const downloadingCasesSlice = createSlice({
  name: "downloadingCases",
  initialState,
  reducers: {
    setIsDownloading(state, action: PayloadAction<boolean>) {
      state.isDownloading = action.payload;
    }
  }
});

export const { setIsDownloading } = downloadingCasesSlice.actions;
export default downloadingCasesSlice.reducer;
